import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig';
import SubscriptionValidResult from '@/SubscriptionValidResult';
import AxiosPostProcessor from './AxiosPostProcessor';
import Axios, { AxiosResponse } from 'axios';
import User from '@/User';
import GpxGeoJson from '@/GpxGeoJson';

export class LoginServiceStatic {
    CachedGpx(savedGpx: string): Promise<AxiosResponse<GpxGeoJson>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/cachedgpx/${savedGpx}`
        return AxiosPostProcessor.postProcess(Axios.get<GpxGeoJson>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    checkSubscription(): Promise<AxiosResponse<SubscriptionValidResult>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/checksubscription`
        return AxiosPostProcessor.postProcess(Axios.get<SubscriptionValidResult>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    clearWantsToUpgrade(): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/clearwantstoupgrade`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }

    loginGet(): Promise<AxiosResponse<User>> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/login`
        return AxiosPostProcessor.postProcess(Axios.get<User>(url, AxiosDefaultRequestConfig.merge({ })));
    }

    loginPostUrl() { return `${process.env.VUE_APP_BASE_URL_API}/api/login`; }

    removeSubscriptionInfo(): Promise<AxiosResponse> {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/secure/user/removesubscriptioninfo`
        return AxiosPostProcessor.postProcess(Axios.get(url, AxiosDefaultRequestConfig.merge({ })));
    }
}
const LoginService = new LoginServiceStatic();
export default LoginService;
